import React from "react";
import leftArrowWhiteIcon from "./arrow-left-white.png";
import leftArrowBlackIcon from "./arrow-left-black.png";
import Button from "../Button";

type Props = {
  position: "left" | "right";
  style: "primary" | "subtle";
  size?: Size;
  onClick: Function;
};

const Arrow: React.FC<Props> = ({ position, style, size, onClick }) => {
  return (
    <Button
      iconOnly
      leadIcon={<img src={style === "primary" ? leftArrowWhiteIcon : leftArrowBlackIcon} />}
      style={style}
      size={size}
      className={position}
      onClick={() => onClick()}
    />
  );
};

export default Arrow;
